import { ApiMode, Tenant } from '@vsolv/core/multi-tenant/domain';

export enum IdField {
  id = 'id',
}

export interface Model {
  id: string;

  tenantId: string | null;
  tenant?: Tenant;

  created: Date;
  modified: Date;
  expired: Date | null;

  key: string;
  mode: ApiMode;
  enabled: boolean;
  name: string | null;
  details: string | null;
  lastUsed: Date | null;
  lastRolled: Date;
  serviceAccount: boolean;
}
